<template>
    <b-modal id="modalSolutionHelp" hide-footer centered size="lg" > 
            <div class="modal-solution">
                <div class="modal-solution__head">
                <h4 class="modal-active__title font-sanpro-bold primary-color-txt font-size-20 title-error">{{solutionHelp.name}}</h4>
                <span @click="$bvModal.hide('modalSolutionHelp')" class="modal-info__close"><i class="icon-close"></i></span>
                </div>
                <div class="modal-solution__body">
                    <p class="css-solution" v-html="solutionHelp.solution"></p>
                </div>
            </div>
    </b-modal>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { apiHelpDetail } from "@/store/common/api"
export default {
    name: "modalSolutionHelp",
    data(){
        return{
            solutionHelp: '',
        }
    },
    computed:{
    //   ...mapState('common', ['loading', 'setIdDetailHelp']),
      ...mapGetters({
          getHelpDetail: `common/getHelpDetail`,
          setIdDetailHelp: `common/setIdDetailHelp`,
          
      }),
    },
    created(){
        apiHelpDetail(this.setIdDetailHelp).then(res =>{
            if(res){
                this.solutionHelp = res.data.data
            }
        })
    },
    watch:{
        setIdDetailHelp: 'fetchDetailHelp'
    },
    methods:{
        ...mapActions('common', [
        'setLoading', 
        'actionHelpDetail',
        ]),

        fetchDetailHelp(){
            apiHelpDetail(this.setIdDetailHelp).then(res =>{
                if(res){
                    this.solutionHelp = res.data.data
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .css-solution{
        p{
            margin: 0;
        }
    }
    .modal-solution{
        background: #fff;
        &__body{
            p{
                margin: 0;
            }
        }
    }
    .modal-info__close {
        top: 0px;
        right: 0px;
    }
</style>